import { render } from "./IconLabel.vue?vue&type=template&id=016fcafc&ts=true"
import script from "./IconLabel.vue?vue&type=script&lang=ts"
export * from "./IconLabel.vue?vue&type=script&lang=ts"

import "./IconLabel.vue?vue&type=style&index=0&id=016fcafc&lang=scss"

import exportComponent from "/Users/colin/Documents/FUSE/code/live/fusestudio.net/Graphite/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__